import { render, staticRenderFns } from "./facturas.vue?vue&type=template&id=4baaed94&scoped=true"
import script from "./facturas.vue?vue&type=script&lang=js"
export * from "./facturas.vue?vue&type=script&lang=js"
import style0 from "./facturas.vue?vue&type=style&index=0&id=4baaed94&prod&scoped=true&lang=css"
import style1 from "./facturas.vue?vue&type=style&index=1&id=4baaed94&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4baaed94",
  null
  
)

export default component.exports